import urljoin from 'url-join';
import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import { IAppApiUninstall } from '../../shared/services/appApiFactory';
import { InstallBTRequest, BTInstalledApp } from '../models';
import { UninstallAppRequest } from '../../shared/models';

class BtSmsApiService implements IAppApiUninstall {
  private version = 'v1';

  public install(request: InstallBTRequest): Promise<void> {
    return api.send('POST', urljoin(config().btHost, this.version, 'app', 'install'), request);
  }

  public uninstall(workspaceId: string, installId: string): Promise<void> {
    const request = {
      workspaceId,
      installId,
    } as UninstallAppRequest;

    return api.send('POST', urljoin(config().btHost, this.version, 'app', 'uninstall'), request);
  }

  public getInstalledApp(workspaceId: string): Promise<BTInstalledApp> {
    return api.send('GET', urljoin(config().btHost, this.version, `app?workspaceid=${workspaceId}`));
  }

  public canUninstall(): boolean {
    return true;
  }

  public getUninstallNotAllowedMessage(): string {
    return '';
  }
}

export const btApi = new BtSmsApiService();
